import XLSX from "xlsx-style-ex"
// 下载功能
export function saveAs(obj, fileName) {
    let tmpa = document.createElement("a");
    tmpa.download = fileName || "未命名";
    // 兼容ie 
    if ("msSaveOrOpenBlob" in navigator) {
        window.navigator.msSaveOrOpenBlob(obj, "下载的文件名" + ".xlsx");
    } else {
        tmpa.href = URL.createObjectURL(obj);
    }
    tmpa.click();
    setTimeout(function () {
        URL.revokeObjectURL(obj);
    }, 100);
}
// 模拟数据
// let data = [{ "功能模块与路径": "\\APP接口测试示例\\登录接口", "用例编号": "s_001", "前置条件": "第一个为前置条件，最后一个为预期结果，需要带相应关键字", "用例名称": "用例编写示例，用例必须有叶子结节", "操作步骤": "操作步骤直接填写，每个步骤一行", "预期结果": "用例必须有叶子结点", "标记": "", "优先级": "3", "用例属性": "", "编制人员": "", "用例设计时间": "2019-02-15", "备注": "" }, { "功能模块与路径": "", "用例编号": "", "前置条件": "", "用例名称": "", "操作步骤": "操作步骤需要按顺序排序", "预期结果": "", "标记": "", "优先级": "", "用例属性": "", "编制人员": "", "用例设计时间": "", "备注": "" }, { "功能模块与路径": "\\APP接口测试示例\\登录接口\\身份证类型登录", "用例编号": "s_002", "前置条件": "我是前置条件，需要“前置条件”为关键字", "用例名称": "身份证登录", "操作步骤": "1，操作步骤1，按次序排列", "预期结果": "我是预期结果", "标记": "", "优先级": "3", "用例属性": "", "编制人员": "", "用例设计时间": "2019-02-15", "备注": "" }, { "功能模块与路径": "", "用例编号": "", "前置条件": "", "用例名称": "", "操作步骤": "2，操作步骤2", "预期结果": "", "标记": "", "优先级": "", "用例属性": "", "编制人员": "", "用例设计时间": "", "备注": "" }, { "功能模块与路径": "", "用例编号": "", "前置条件": "", "用例名称": "", "操作步骤": "3，我是操作步骤3，按次序排列", "预期结果": "", "标记": "", "优先级": "", "用例属性": "", "编制人员": "", "用例设计时间": "", "备注": "" }, { "功能模块与路径": "\\APP接口测试示例\\登录接口\\身份证类型登录", "用例编号": "s_003", "用例名称": "用例名称一定要长-登录失败", "操作步骤": "我是操作步骤", "预期结果": "如果这个是预期结果，则上层为用例", "标记": "", "优先级": "3", "用例属性": "", "编制人员": "", "用例设计时间": "2019-02-15", "备注": "" }, { "功能模块与路径": "\\APP接口测试示例\\登录接口", "用例编号": "s_004", "用例名称": "账户类型登录", "预期结果": "账户为空3", "标记": "", "优先级": "3", "用例属性": "", "编制人员": "", "用例设计时间": "2019-02-15", "备注": "" }]
// 配置文件类型
const wopts = { bookType: 'xlsx', bookSST: true, type: 'binary', cellStyles: true };
export function downloadExl(json, type,fileTitle,str) {
    let tmpdata = json[0];
    json.unshift({});
    let keyMap = []; //获取keys
    for (let k in tmpdata) {
        keyMap.push(k);
        json[0][k] = k;
    }
    tmpdata = [];//用来保存转换好的json 
    json.map((v, i) => keyMap.map((k, j) => Object.assign({}, {
        v: v[k],
        position: (j > 25 ? getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1)
    }))).reduce((prev, next) => prev.concat(next)).forEach((v, i) => tmpdata[v.position] = {
        v: v.v
    });
    let outputPos = Object.keys(tmpdata); //设置区域,比如表格从A1到D10
    let bool = true;
    for(let i=0;i<outputPos.length;i++){
        if(outputPos[i].includes('A2')){
            bool = false;
        }else{
            if(bool){
                tmpdata[outputPos[i]].s = { font: { sz: 12, bold: false, color: { rgb: "333333" } }, fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "4d922e" } } };//<====设置xlsx单元格样式
            }
        }
        
        if(tmpdata[outputPos[i]].v.includes(str)){
            tmpdata[outputPos[i]].s = { font: { sz: 12, bold: false, color: { rgb: "333333" } }, fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "FFFF00" }} };//<====设置xlsx单元格样式
        }
        
    }
    
    // tmpdata["!merges"] = [{
    //     s: { c: 1, r: 0 },
    //     e: { c: 4, r: 0 }
    // }];//<====合并单元格 
    let tmpWB = {
        SheetNames: ['sheet1'], //保存的表标题
        Sheets: {
            'sheet1': Object.assign({},
                tmpdata, //内容
                {
                    '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] //设置填充区域
                })
        }
    };
    let tmpDown = new Blob([s2ab(XLSX.write(tmpWB,
        { bookType: (type == undefined ? 'xlsx' : type), bookSST: false, type: 'binary' }//这里的数据是用来定义导出的格式类型
    ))], {
            type: ""
        });
    saveAs(tmpDown, fileTitle + '-' + new Date().toLocaleString() + '.' + (wopts.bookType == "biff2" ? "xls" : wopts.bookType));
}
// 获取26个英文字母用来表示excel的列
export function getCharCol(n) {
    let temCol = '',
        s = '',
        m = 0
    while (n > 0) {
        m = n % 26 + 1
        s = String.fromCharCode(m + 64) + s
        n = (n - m) / 26
    }
    return s
}
export function s2ab(s) {
    if (typeof ArrayBuffer !== 'undefined') {
        let buf = new ArrayBuffer(s.length);
        let view = new Uint8Array(buf);
        for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    } else {
        let buf = new Array(s.length);
        for (let i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
}